<template>
    <a-modal :visible="visible" @ok="process" @cancel="cancel" :width="getScreen ? '90%' : '90%'" :confirmLoading="loading.confirm"
      :footer="false" :maskClosable="false">
      <span slot="title"> <a-icon type="reconciliation" />&nbsp;Detil Klaim</span>
  
      <a-row :gutter="24">
        <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
          <ul class="m-list-wrapper bordered">
            <li>
              <span class="m-list-title" for>Create Date</span>
              <span class="m-list-desc">{{ dtl.header.create_dt }}</span>
            </li>
            <li>
              <span class="m-list-title" for>Total Claim</span>
              <span class="m-list-desc">{{ formatCurrency('IDR',dtl.header.total_klaim) }}</span>
            </li>
            <!-- <li>
              <span class="m-list-title" for>Total Claim</span>
              <span class="m-list-desc">{{ dtl.header.total_pd && Number(dtl.header.total_pd)>0 ? formatCurrency('IDR',dtl.header.total_pd) : formatCurrency('USD',dtl.header.total_ln) }}</span>
            </li> -->
          </ul>
        </a-col>
        <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
          <ul class="m-list-wrapper bordered">
            <li>
              <a-row :gutter="24">
                <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
                  <span class="m-list-title" for>Total End User</span>
                  <span class="m-list-desc">{{ dtl.header.total_end_user }}</span>
                </a-col>
                <a-col :xs="{ span: 24 }" :lg="{ span: 12 }">
                  <span class="m-list-title" for>Credit Card No.</span>
                  <span class="m-list-desc">{{ dtl.header.no_cc }}</span>
                </a-col>
              </a-row>
            </li>
            <li>
              <span class="m-list-title" for>Claim Tiket No.</span>
              <span class="m-list-desc">{{ dtl.header.ticket_claim_no }}</span>
            </li>
          </ul>
        </a-col>
      </a-row>
      <a-table
        :rowKey="(record, index) => {return index;}"
        :columns="columns"
        :dataSource="dtl.dtl_kegiatan"
        :pagination="pagination"
        size="small"
        bordered
        class="table-dtl margin-top"
      >
        <template slot="activity" slot-scope="item">
          {{ moment(item.tanggal).format("DD-MM-YYYY") }}
        </template>
          <template slot="desc" slot-scope="item">
          {{ item.description }}
        </template>
        <template slot="no_sppd" slot-scope="item">
          {{ item.no_sppd }}
        </template>
        <template slot="end_user" slot-scope="item">
          {{ item.end_user }}
        </template>
        <template slot="insentive" slot-scope="item">
          {{ formatCurrency('IDR',item.value) }}
        </template>
      </a-table>
    </a-modal>
  </template>
  <script>
  import { mapGetters } from "vuex";
  import GlobalMethod from "@/mixins/GlobalMethod.js";
  import CurrencyFormat from "@/mixins/CurrencyFormat";
  import _ from "lodash";
  import axios from "axios";
  import moment from "moment";
  
  export default {
    name: "DialogDetil",
    props: ["visible","dtl"],
    mixins: [CurrencyFormat,GlobalMethod],
    data(){
      const columns = [
        {
          title: "Date",
          key: "activity",
          width: "120px",
          align: "center",
          scopedSlots: { customRender: "activity" },
          sorter: (a, b) => a.tanggal - b.tanggal,
        },
        {
          title: "Desc",
          key: "desc",
          scopedSlots: { customRender: "desc" },
          sorter: (a, b) => a.kegiatan - b.kegiatan,
        },
        {
          title: "PD No",
          key: "no_sppd",
          width: "200px",
          align: "left",
          scopedSlots: { customRender: "no_sppd" },
          sorter: (a, b) => a.no_sppd - b.no_sppd,
        },
        {
          title: "End User",
          key: "end_user",
          align: "center",
          scopedSlots: { customRender: "end_user" },
          sorter: (a, b) => a.end_user - b.end_user,
        },
        {
          title: "Value",
          key: "insentive",
          align: "right",
          scopedSlots: { customRender: "insentive" },
        },
      ]
      return {
        columns,
        loading: {
          confirm: false
        },
        pagination: {
          onChange: (page) => {},
          pageSize: 5,
          size: "small",
        },
      }
    },
    computed: {
      ...mapGetters(["getScreen", "getAuth"]),
    },
    methods:{
      moment,
      process(){
  
      },
      cancel(){
        Event.$emit("closeDiagDtl");
      }
    }
  }
  </script>
  <style lang="less">
  .table-dtl{
    th{
      text-align: center!important;
    }
  }
  </style>